import React from 'react';

import { TableStyled } from './style';
import { ColumnProps } from './types/ColumnProps';

type Props<T> = {
  columns: Array<ColumnProps<T>>;
  data?: T[];
};

function Table<T>({ data, columns }: Props<T>) {
  const headers = columns.map((column, index) => (
    <th key={`headCell-${index}`} className="table-th">
      {column.label}
    </th>
  ));

  const rows = !data?.length ? (
    <tr>
      <td colSpan={columns.length} style={{ textAlign: 'center' }}>
        No data
      </td>
    </tr>
  ) : (
    data.map((row, index) => (
      <tr key={`row-${index}`}>
        {columns.map((column, index2) => {
          const value = column.render
            ? column.render(column, row)
            : (row[column.key as keyof T] as React.ReactNode);

          return (
            <td key={`cell-${index2}`} className="table-td">
              {value}
            </td>
          );
        })}
      </tr>
    ))
  );

  return (
    <TableStyled>
      <table className="table">
        <thead className="t-head">
          <tr className="t-head-row">{headers}</tr>
        </thead>
        <tbody className="t-body">{rows}</tbody>
      </table>
    </TableStyled>
  );
}

export default Table;
